import { ID } from 'shared/types/id';

export enum DefaultSideOptions {
  Inbox = 'inbox',
  AllTasks = 'all-tasks',
  Habits = 'habits',
}

export enum ExtraSideOptions {
  Tag = 'tag',
  SmartList = 'smart-list',
}

export type DefaultViewMode = {
  type: DefaultSideOptions;
};

export type ExtraViewMode = { type: ExtraSideOptions; id: ID; name: string };

export type ViewMode = DefaultViewMode | ExtraViewMode;
